var map = {
	"./layouts/card": 16,
	"./layouts/card/": 16,
	"./layouts/card/index": 16,
	"./layouts/card/index.tsx": 16,
	"./layouts/card/style.module": 104,
	"./layouts/card/style.module.scss": 104,
	"./layouts/components/breadcrumbs": 136,
	"./layouts/components/breadcrumbs/": 136,
	"./layouts/components/breadcrumbs/index": 136,
	"./layouts/components/breadcrumbs/index.tsx": 136,
	"./layouts/components/breadcrumbs/style.module": 196,
	"./layouts/components/breadcrumbs/style.module.scss": 196,
	"./layouts/components/container": 49,
	"./layouts/components/container/": 49,
	"./layouts/components/container/index": 49,
	"./layouts/components/container/index.tsx": 49,
	"./layouts/components/container/style.module": 138,
	"./layouts/components/container/style.module.scss": 138,
	"./layouts/components/footer": 137,
	"./layouts/components/footer/": 137,
	"./layouts/components/footer/index": 137,
	"./layouts/components/footer/index.tsx": 137,
	"./layouts/components/footer/style.module": 95,
	"./layouts/components/footer/style.module.scss": 95,
	"./layouts/components/loading_indicator": 56,
	"./layouts/components/loading_indicator/": 56,
	"./layouts/components/loading_indicator/index": 56,
	"./layouts/components/loading_indicator/index.tsx": 56,
	"./layouts/components/nav_bar": 103,
	"./layouts/components/nav_bar/": 103,
	"./layouts/components/nav_bar/index": 103,
	"./layouts/components/nav_bar/index.tsx": 103,
	"./layouts/components/nav_bar/standalone": 369,
	"./layouts/components/nav_bar/standalone.tsx": 369,
	"./layouts/components/nav_bar/style.module": 37,
	"./layouts/components/nav_bar/style.module.scss": 37,
	"./layouts/components/notice_banner": 94,
	"./layouts/components/notice_banner/": 94,
	"./layouts/components/notice_banner/assets/sale_tag_icon": 197,
	"./layouts/components/notice_banner/assets/sale_tag_icon.svg": 197,
	"./layouts/components/notice_banner/index": 94,
	"./layouts/components/notice_banner/index.tsx": 94,
	"./layouts/components/notice_banner/standalone": 370,
	"./layouts/components/notice_banner/standalone.tsx": 370,
	"./layouts/components/notice_banner/style.module": 198,
	"./layouts/components/notice_banner/style.module.scss": 198,
	"./layouts/page": 106,
	"./layouts/page/": 106,
	"./layouts/page/index": 106,
	"./layouts/page/index.tsx": 106,
	"./layouts/page/style.module": 96,
	"./layouts/page/style.module.scss": 96,
	"./layouts/types": 371,
	"./layouts/types.ts": 371,
	"./marketing/pages/home/toefl": 1581,
	"./marketing/pages/home/toefl/": 1581,
	"./marketing/pages/home/toefl/index": 1581,
	"./marketing/pages/home/toefl/index.tsx": 1581,
	"./marketing/pages/home/toefl/sections/ai": 1172,
	"./marketing/pages/home/toefl/sections/ai/": 1172,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature": 1801,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_coaching_feature.png": 1801,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature": 1802,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_explanations_feature.png": 1802,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature": 1803,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_speaking_grading_feature.png": 1803,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature": 1804,
	"./marketing/pages/home/toefl/sections/ai/assets/ai_writing_grading_feature.png": 1804,
	"./marketing/pages/home/toefl/sections/ai/assets/ets_badge": 1805,
	"./marketing/pages/home/toefl/sections/ai/assets/ets_badge.svg": 1805,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg": 1806,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_bg.svg": 1806,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon": 1807,
	"./marketing/pages/home/toefl/sections/ai/assets/sparkle_icon.svg": 1807,
	"./marketing/pages/home/toefl/sections/ai/index": 1172,
	"./marketing/pages/home/toefl/sections/ai/index.tsx": 1172,
	"./marketing/pages/home/toefl/sections/ai/style.module": 1808,
	"./marketing/pages/home/toefl/sections/ai/style.module.scss": 1808,
	"./marketing/pages/home/toefl/sections/apps": 1173,
	"./marketing/pages/home/toefl/sections/apps/": 1173,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon": 1809,
	"./marketing/pages/home/toefl/sections/apps/assets/app_store_icon.svg": 1809,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon": 1810,
	"./marketing/pages/home/toefl/sections/apps/assets/device_icon.svg": 1810,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app": 1811,
	"./marketing/pages/home/toefl/sections/apps/assets/flashcard_app.png": 1811,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon": 1812,
	"./marketing/pages/home/toefl/sections/apps/assets/play_store_icon.svg": 1812,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app": 1813,
	"./marketing/pages/home/toefl/sections/apps/assets/prep_app.png": 1813,
	"./marketing/pages/home/toefl/sections/apps/index": 1173,
	"./marketing/pages/home/toefl/sections/apps/index.tsx": 1173,
	"./marketing/pages/home/toefl/sections/features": 1174,
	"./marketing/pages/home/toefl/sections/features/": 1174,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature": 1814,
	"./marketing/pages/home/toefl/sections/features/assets/analytics_feature.png": 1814,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature": 1815,
	"./marketing/pages/home/toefl/sections/features/assets/practice_tests_feature.png": 1815,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature": 1816,
	"./marketing/pages/home/toefl/sections/features/assets/score_predictor_feature.png": 1816,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon": 1817,
	"./marketing/pages/home/toefl/sections/features/assets/star_icon.svg": 1817,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature": 1818,
	"./marketing/pages/home/toefl/sections/features/assets/student_help_feature.png": 1818,
	"./marketing/pages/home/toefl/sections/features/index": 1174,
	"./marketing/pages/home/toefl/sections/features/index.tsx": 1174,
	"./marketing/pages/home/toefl/sections/official_questions": 1178,
	"./marketing/pages/home/toefl/sections/official_questions/": 1178,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen": 1827,
	"./marketing/pages/home/toefl/sections/official_questions/assets/official_questions_screen.png": 1827,
	"./marketing/pages/home/toefl/sections/official_questions/index": 1178,
	"./marketing/pages/home/toefl/sections/official_questions/index.tsx": 1178,
	"./marketing/pages/home/toefl/sections/official_questions/style.module": 708,
	"./marketing/pages/home/toefl/sections/official_questions/style.module.scss": 708,
	"./marketing/pages/home/toefl/sections/value_props": 1175,
	"./marketing/pages/home/toefl/sections/value_props/": 1175,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles": 1819,
	"./marketing/pages/home/toefl/sections/value_props/assets/concentric_circles.svg": 1819,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon": 1820,
	"./marketing/pages/home/toefl/sections/value_props/assets/magic_wand_icon.svg": 1820,
	"./marketing/pages/home/toefl/sections/value_props/index": 1175,
	"./marketing/pages/home/toefl/sections/value_props/index.tsx": 1175,
	"./marketing/pages/home/toefl/sections/value_props/style.module": 2201,
	"./marketing/pages/home/toefl/sections/value_props/style.module.scss": 2201,
	"./marketing/pages/home/toefl/sections/video_based_learning": 1176,
	"./marketing/pages/home/toefl/sections/video_based_learning/": 1176,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card": 1821,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/focused_lesson_card.png": 1821,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg": 1822,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lesson_cards_bg.png": 1822,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot": 1823,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/lucas_headshot.png": 1823,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon": 1824,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/play_icon.svg": 1824,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail": 1825,
	"./marketing/pages/home/toefl/sections/video_based_learning/assets/video_thumbnail.png": 1825,
	"./marketing/pages/home/toefl/sections/video_based_learning/index": 1176,
	"./marketing/pages/home/toefl/sections/video_based_learning/index.tsx": 1176,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module": 707,
	"./marketing/pages/home/toefl/sections/video_based_learning/style.module.scss": 707,
	"./marketing/pages/home/toefl/sections/wall_of_love": 1177,
	"./marketing/pages/home/toefl/sections/wall_of_love/": 1177,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot": 1826,
	"./marketing/pages/home/toefl/sections/wall_of_love/assets/aybige_headshot.png": 1826,
	"./marketing/pages/home/toefl/sections/wall_of_love/index": 1177,
	"./marketing/pages/home/toefl/sections/wall_of_love/index.tsx": 1177,
	"./marketing/pages/home/toefl/style.module": 1828,
	"./marketing/pages/home/toefl/style.module.scss": 1828,
	"./marketing/pages/plans/toefl": 1582,
	"./marketing/pages/plans/toefl/": 1582,
	"./marketing/pages/plans/toefl/index": 1582,
	"./marketing/pages/plans/toefl/index.tsx": 1582,
	"./marketing/pages/plans/toefl/sections/testimonials": 1179,
	"./marketing/pages/plans/toefl/sections/testimonials/": 1179,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot": 1829,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/mateus_headshot.png": 1829,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot": 1830,
	"./marketing/pages/plans/toefl/sections/testimonials/assets/nishant_headshot.png": 1830,
	"./marketing/pages/plans/toefl/sections/testimonials/index": 1179,
	"./marketing/pages/plans/toefl/sections/testimonials/index.tsx": 1179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2539;